module.exports = __webpack_public_path__ + "static/media/logo.9c118b22.png";